import DashboardLayout from '../components/DashboardLayout';
import { CHANGELOG } from '../data/changelog';
import { Sparkle, CheckCircle } from '@phosphor-icons/react';

const fmtDate = (iso) => {
  const d = new Date(`${iso}T00:00:00`);
  if (isNaN(d.getTime())) return iso;
  return d.toLocaleDateString('en-US', { month: 'long', day: 'numeric', year: 'numeric' });
};

export default function WhatsNewPage() {
  return (
    <DashboardLayout>
      <div className="space-y-8" data-testid="whats-new-page">
        {/* Header */}
        <div>
          <p className="label-uppercase mb-1" style={{ color: '#9a9488' }}>Updates</p>
          <h1
            className="text-4xl sm:text-5xl font-bold tracking-tight"
            style={{ color: '#09090B', fontFamily: 'Cabinet Grotesk, sans-serif' }}
            data-testid="whats-new-title"
          >
            What&rsquo;s New
          </h1>
          <p className="mt-3 text-base max-w-2xl" style={{ color: '#52525B' }}>
            We&rsquo;re always improving your portal. Here&rsquo;s a running history of the updates
            we&rsquo;ve shipped, newest first.
          </p>
        </div>

        {/* Timeline */}
        <div className="relative">
          {/* vertical line */}
          <div
            className="absolute top-2 bottom-2 left-[7px] w-px hidden sm:block"
            style={{ backgroundColor: '#E4D9C4' }}
            aria-hidden="true"
          />
          <div className="space-y-8">
            {CHANGELOG.map((release, idx) => (
              <div key={release.date} className="sm:pl-10 relative" data-testid={`release-${release.date}`}>
                {/* node */}
                <div
                  className="absolute left-0 top-1.5 w-4 h-4 rounded-full items-center justify-center hidden sm:flex"
                  style={{ backgroundColor: idx === 0 ? '#141b4d' : '#ffffff', border: '2px solid #141b4d' }}
                  aria-hidden="true"
                >
                  {idx === 0 && <Sparkle weight="fill" className="w-2 h-2" style={{ color: '#ffd100' }} />}
                </div>

                <div className="card-swiss">
                  <div className="flex items-center justify-between gap-3 flex-wrap mb-3">
                    <div>
                      <p className="text-sm font-semibold" style={{ color: '#1d57a5' }} data-testid={`release-date-${release.date}`}>
                        {fmtDate(release.date)}
                      </p>
                      {release.title && (
                        <h2 className="text-lg font-semibold mt-0.5" style={{ color: '#09090B', fontFamily: 'Cabinet Grotesk, sans-serif' }}>
                          {release.title}
                        </h2>
                      )}
                    </div>
                    {idx === 0 && (
                      <span
                        className="text-[10px] font-bold uppercase tracking-wide px-2 py-1"
                        style={{ backgroundColor: '#141b4d', color: '#ffffff' }}
                      >
                        Latest
                      </span>
                    )}
                  </div>
                  <ul className="space-y-2.5">
                    {release.items.map((item, i) => (
                      <li key={i} className="flex items-start gap-2.5 text-sm leading-relaxed" style={{ color: '#3f3f46' }}>
                        <CheckCircle weight="duotone" className="w-4 h-4 flex-shrink-0 mt-0.5" style={{ color: '#006747' }} />
                        <span>{item}</span>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Footer note */}
        <p className="text-sm pt-2" style={{ color: '#9a9488' }}>
          Have an idea for something you&rsquo;d like to see? Use the{' '}
          <span className="font-medium" style={{ color: '#52525B' }}>Feedback</span> button in the
          corner &mdash; we read every note.
        </p>
      </div>
    </DashboardLayout>
  );
}
